export const resetForm = {
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
